module.exports = __webpack_public_path__ + "img/charts2.c0062f81.jpg";